module.exports = __webpack_public_path__ + "img/sankaku_95_red.ad166162.png";